import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDha7Sqn-gGfkIQHisdYoZI3c-V0lQ7CZc",
  authDomain: "misas-app.firebaseapp.com",
  projectId: "misas-app",
  storageBucket: "misas-app.appspot.com",
  messagingSenderId: "659133535184",
  appId: "1:659133535184:web:e93e941073980071289fd5",
  measurementId: "G-ERKLW58V2V"
};

const app = initializeApp(firebaseConfig);

let messaging = null;

// Only initialize messaging in secure contexts (HTTPS or localhost) where Service Worker is available.
// Insecure HTTP contexts (e.g. testing via LAN IP http://192.168.x.x) disable ServiceWorker in browsers.
if (
  typeof window !== 'undefined' &&
  typeof navigator !== 'undefined' &&
  'serviceWorker' in navigator &&
  Boolean(navigator.serviceWorker) &&
  (window.isSecureContext || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.warn('[Firebase] Messaging initialization skipped (unsupported in this context):', error?.message);
  }
}

export { messaging };
export default app;